import { render, staticRenderFns } from "./DeviceMessageList.vue?vue&type=template&id=5c0dc272&scoped=true&"
import script from "./DeviceMessageList.vue?vue&type=script&lang=js&"
export * from "./DeviceMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0dc272",
  null
  
)

export default component.exports